<template>
    <section class="why-choose-wrap style1 pt-100 pb-100" style="
      background-color: #fffbf0 !important">
        <div class="container">
            <div class="row gx-5 align-items-center">
                <div class="col-lg-6">
                    <div class="">
                        <img src="../../assets/images/why-choose-us/whimg.jpg" style="width: 82%;padding-top: 10%;" alt="Image">
                        <img class="wh-shape-one bounce" src="../../assets/images/why-choose-us/wh-shape-1.png" alt="Image">
                        <img class="wh-shape-two animationFramesTwo" src="../../assets/images/why-choose-us/wh-shape-2.png" alt="Image">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="wh-content">
                        <div class="content-title style1">
                            <span>Pourquoi nous choisir ?</span>
                            <h4 style="text-transform: uppercase !important;" > Bénéficiez d'une formation théologique complète, d'un accompagnement pastoral et de ressources pédagogiques enrichissantes
    </h4>
                        </div>
                        <div class="feature-item-wrap">
                            <div class="feature-item">
                                <span class="feature-icon">
                                    <i class="flaticon-graph"></i>
                                </span>
                                <div class="feature-text">
                                    <h3>Formation Théologique</h3>
                                    <p>Découvrez un programme complet d’initiation à la théologie pour approfondir vos connaissances de la foi chrétienne .</p>
                                </div>
                            </div>
                            <div class="feature-item">
                                <span class="feature-icon">
                                    <i class="flaticon-loan-1"></i>
                                </span>
                                <div class="feature-text">
                                    <h3>Pastorale et Mission</h3>
                                    <p>Participez à des activités pastorales et missionnaires pour mettre votre foi en pratique et servir votre communauté.</p>
                                </div>
                            </div>
                            <div class="feature-item">
                                <span class="feature-icon">
                                    <i class="flaticon-computer"></i>
                                </span>
                                <div class="feature-text">
                                    <h3>Ressources et Documentation</h3>
                                    <p>Accédez à une bibliothèque de cours, de livres et de supports pédagogiques pour approfondir votre formation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'WhyChooseUs'
}
</script>